import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import * as RouterFile from "./router";

const router =
  RouterFile.router ??
  (typeof RouterFile.getRouter === "function" ? RouterFile.getRouter() : undefined) ??
  (RouterFile as any).default;

if (!router) {
  throw new Error("Router no pudo inicializarse.");
}

if (typeof window !== "undefined") {
  console.log("[router bootstrap] mounting RouterProvider with router instance", {
    hasRouter: Boolean(router),
    pathname: window.location.pathname,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
